module.exports = __webpack_public_path__ + "static/media/different-equation-bg-2.7331f4ae.webp";